import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Floor5Component = ({unitStatus}) => {
  console.log('unitStatus', unitStatus);
    useEffect(() => {
        // Initialize ImageMapPro after the component mounts
        const initializeImageMap = () => {
            if (window.ImageMapPro) {
                window.ImageMapPro.init('#image-map-pro', {
                  "id": "0c0620fd-7262-416b-8424-cc5e234b4a86", "general": {
    "name": "Floor 3,5"
}, "artboards": [{
"background_type": "image",
"image_url": "https://greendirectorydata.s3.us-east-2.amazonaws.com/GPP8%20KP%203-%203rd%2C%205th%20FLOOR%20copy.png",
"width": 3811,
"height": 2567,
"use_image_size": true,
"children": [{
    "id": "ffe411d5-308b-458f-b5dc-591921f8f44a",
    "title": "Poly",
    "type": "poly",
    "x": 48.561151079136685,
    "y": 1.83094128393234,
    "width": 17.985611510791365,
    "height": 45.71324475285373,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[12].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[12].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[12].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[12] && unitStatus[12].status
            ? `<a href="${unitStatus[12].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/13' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[12].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[12].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/13';"
    // },
    "x_image_background": 48.561151079136685,
    "y_image_background": 1.83094128393234,
    "points": [{
        "x": 99.19999999999999,
        "y": 0.23364485981308405
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 21.72897196261682
    }, {
        "x": 43.20000000000001,
        "y": 21.72897196261682
    }, {
        "x": 42.800000000000004,
        "y": 94.39252336448598
    }, {
        "x": 51.600000000000016,
        "y": 94.62616822429906
    }, {
        "x": 51.2,
        "y": 100
    }, {
        "x": 69.80039896087871,
        "y": 99.88201429613828
    }, {
        "x": 70,
        "y": 95.09345794392523
    }, {
        "x": 100,
        "y": 94.62616822429906
    }]
}, {
    "id": "0313644b-8b8d-460d-a8a8-de7ed743d882",
    "title": "Poly",
    "type": "poly",
    "x": 66.4748201438849,
    "y": 1.83094128393234,
    "width": 32.086330935251794,
    "height": 45.60643810623492,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[11].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[11].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[11].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[11] && unitStatus[11].status
            ? `<a href="${unitStatus[11].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/12' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[11].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[11].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/12';"
    // },
    "x_image_background": 66.4748201438849,
    "y_image_background": 1.83094128393234,
    "points": [{
        "x": 0,
        "y": 94.37939110070258
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 100,
        "y": 0.234192037470726
    }, {
        "x": 100,
        "y": 36.768149882903984
    }, {
        "x": 31.614349775784756,
        "y": 36.768149882903984
    }, {
        "x": 31.614349775784756,
        "y": 94.61358313817331
    }, {
        "x": 26.45739910313901,
        "y": 95.08196721311475
    }, {
        "x": 26.905829596412556,
        "y": 100
    }, {
        "x": 16.81614349775785,
        "y": 100
    }, {
        "x": 16.367713004484305,
        "y": 94.61358313817331
    }]
}, {
    "id": "302ed5c5-cc67-4c5c-8da5-c0d54af1e5ce",
    "title": "Poly",
    "type": "poly",
    "x": 86.2589928057554,
    "y": 54.70023136024682,
    "width": 12.230215827338128,
    "height": 43.89753176033385,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[10].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[10].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[10].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[10] && unitStatus[10].status
            ? `<a href="${unitStatus[10].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/11' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[10].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[10].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/11';"
    // },
    "x_image_background": 86.2589928057554,
    "y_image_background": 54.70023136024682,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 0.588235294117658,
        "y": 100
    }, {
        "x": 53.529411764705834,
        "y": 99.27007299270073
    }, {
        "x": 54.11764705882349,
        "y": 83.2116788321168
    }, {
        "x": 86.4705882352941,
        "y": 82.96836982968371
    }, {
        "x": 86.4705882352941,
        "y": 26.277372262773717
    }, {
        "x": 100,
        "y": 26.277372262773717
    }, {
        "x": 99.41176470588235,
        "y": 0.4866180048661829
    }]
}, {
    "id": "e7344383-969d-4486-ae47-169e0539898a",
    "title": "Poly",
    "type": "poly",
    "x": 75.8273381294964,
    "y": 54.80703800686564,
    "width": 10.575539568345334,
    "height": 43.363498527239756,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[9].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[9].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[9].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[9] && unitStatus[9].status
            ? `<a href="${unitStatus[9].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/10' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[9].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[9].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/10';"
    // },
    "x_image_background": 75.8273381294964,
    "y_image_background": 54.80703800686564,
    "points": [{
        "x": 0,
        "y": 0.49261083743842365
    }, {
        "x": 96.5986394557823,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 1.3605442176870748,
        "y": 100
    }]
}, {
    "id": "a378f433-d127-43d1-8191-9d119cbf8230",
    "title": "Poly",
    "type": "poly",
    "x": 65.46762589928058,
    "y": 55.020651300103275,
    "width": 10.35971223021582,
    "height": 43.470305173858584,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[8].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[8].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[8].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[8] && unitStatus[8].status
            ? `<a href="${unitStatus[8].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/9' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[8].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[8].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/9';"
    // },
    "x_image_background": 65.46762589928058,
    "y_image_background": 55.020651300103275,
    "points": [{
        "x": 0,
        "y": 0.2457002457002457
    }, {
        "x": 99.30555555555556,
        "y": 0
    }, {
        "x": 100,
        "y": 99.01719901719902
    }, {
        "x": 0.6944444444444444,
        "y": 100
    }]
}, {
    "id": "63e5ed32-e384-4399-98da-638e32680c3a",
    "title": "Poly",
    "type": "poly",
    "x": 55.17985611510792,
    "y": 54.91384465348445,
    "width": 10.359712230215827,
    "height": 43.36349852723976,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[7].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[7].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[7].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[7] && unitStatus[7].status
            ? `<a href="${unitStatus[7].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/8' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[7].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[7].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/8';"
    // },
    "x_image_background": 55.17985611510792,
    "y_image_background": 54.91384465348445,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 98.61111111111111,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 1.3888888888888888,
        "y": 100
    }]
}, {
    "id": "4da5c3f2-4c68-4d52-a21e-871d2ca6a551",
    "title": "Poly",
    "type": "poly",
    "x": 44.82014388489209,
    "y": 54.91384465348445,
    "width": 10.57553956834532,
    "height": 43.470305173858584,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[6].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[6].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[6].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[6] && unitStatus[6].status
            ? `<a href="${unitStatus[6].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/7' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[6].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[6].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/7';"
    // },
    "x_image_background": 44.82014388489209,
    "y_image_background": 54.91384465348445,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 98.63945578231292,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0.6802721088435374,
        "y": 100
    }]
}, {
    "id": "ed36307f-90fe-40f9-a2b2-b37a11ca82e2",
    "title": "Poly",
    "type": "poly",
    "x": 34.60431654676259,
    "y": 54.91384465348445,
    "width": 10.28776978417266,
    "height": 43.577111820477406,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[5].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[5].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[5].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[5] && unitStatus[5].status
            ? `<a href="${unitStatus[5].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/6' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[5].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[5].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/6';"
    // },
    "x_image_background": 34.60431654676259,
    "y_image_background": 54.91384465348445,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 100,
        "y": 0.24509803921568626
    }, {
        "x": 99.3006993006993,
        "y": 100
    }, {
        "x": 0,
        "y": 99.50980392156863
    }]
}, {
    "id": "0e2494f9-4797-4ee8-8887-4d9d2674170a",
    "title": "Poly",
    "type": "poly",
    "x": 24.244604316546763,
    "y": 54.91384465348445,
    "width": 10.28776978417266,
    "height": 43.36349852723976,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[4].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[4].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[4].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[4] && unitStatus[4].status
            ? `<a href="${unitStatus[4].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/5' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[4].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[4].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/5';"
    // },
    "x_image_background": 24.244604316546763,
    "y_image_background": 54.91384465348445,
    "points": [{
        "x": 0,
        "y": 0
    }, {
        "x": 100,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0,
        "y": 99.50738916256158
    }]
}, {
    "id": "599df60a-a2d5-4279-aafd-c6d08f09ba06",
    "title": "Poly",
    "type": "poly",
    "x": 13.956834532374101,
    "y": 54.91384424540578,
    "width": 10.287769784172662,
    "height": 43.47030558193726,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[3].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[3].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[3].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[3] && unitStatus[3].status
            ? `<a href="${unitStatus[3].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/4' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[3].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[3].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/4';"
    // },
    "x_image_background": 13.956834532374101,
    "y_image_background": 55.020651300103275,
    "points": [{
        "x": 0,
        "y": 0.2457011821464589
    }, {
        "x": 100,
        "y": 0
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 0.6993006993006949,
        "y": 99.75429975660626
    }]
}, {
    "id": "39adb400-f5a9-4ac6-8123-f8d5f7c34d68",
    "title": "Poly",
    "type": "poly",
    "x": 3.3650020901247752,
    "y": 54.80690762765834,
    "width": 10.575539568345324,
    "height": 43.57711182047739,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[2].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[2].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[2].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[2] && unitStatus[2].status
            ? `<a href="${unitStatus[2].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/3' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[2].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[2].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/3';"
    // },
    "x_image_background": 3.3650020901247752,
    "y_image_background": 54.80690762765834,
    "points": [{
        "x": 2.0408163265306123,
        "y": 0
    }, {
        "x": 99.31972789115646,
        "y": 0.24509803921568626
    }, {
        "x": 100,
        "y": 100
    }, {
        "x": 37.41496598639456,
        "y": 100
    }, {
        "x": 38.095238095238095,
        "y": 83.33333333333334
    }, {
        "x": 0,
        "y": 83.08823529411765
    }]
}, {
    "id": "a9ed4648-53c5-4957-bb0e-d1b7c6adf7e2",
    "title": "Poly",
    "type": "poly",
    "x": 3.7690438469536867,
    "y": 1.938473164891754,
    "width": 19.56834532374101,
    "height": 45.39282481299728,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[1].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[1].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[1].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[1] && unitStatus[1].status
            ? `<a href="${unitStatus[1].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/2' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[1].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[1].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/2';"
    // },
    "x_image_background": 3.7690438469536867,
    "y_image_background": 1.938473164891754,
    "points": [{
        "x": 99.63235294117648,
        "y": 0
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0,
        "y": 27.52941176470588
    }, {
        "x": 48.16176470588236,
        "y": 27.764705882352942
    }, {
        "x": 47.98418333579697,
        "y": 94.75072346439285
    }, {
        "x": 55.60661764705881,
        "y": 94.9411766953367
    }, {
        "x": 55.882352941176485,
        "y": 100
    }, {
        "x": 72.79411764705883,
        "y": 99.76470588235294
    }, {
        "x": 72.79411764705883,
        "y": 95.52941176470587
    }, {
        "x": 100,
        "y": 95.05882352941177
    }]
}, {
    "id": "45466dc2-9dff-4fad-9209-1e9eddba1764",
    "title": "Poly",
    "type": "poly",
    "x": 23.38129496402878,
    "y": 1.724134637313523,
    "width": 17.841726618705035,
    "height": 45.530230273569245,
    "default_style": {
        "opacity": 0
    },
    "mouseover_style": {
        "background_color": unitStatus && unitStatus[0].status === "available" ? "#0e2b33" : "#a6a1a6",
        "background_opacity": 1
    },
    "tooltip_style": {
        "background_color": "#0e2b33"
    },
    "tooltip_content": [{
        "type": "Heading",
        "text": unitStatus && unitStatus[0].unitTitle,
        "heading": "h3",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "italiana",
            "fontSize": 20.8,
            "lineHeight": "normal",
            "color": "#ffffff",
            "textAlign": "left"
          },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "270c0fda-a8bd-4796-8a8f-b458f0c00b57"
    },
    // {
    //     "type": "Paragraph",
    //     "text": unitStatus && unitStatus[0].marketing,
    //     "other": {
    //         "id": "",
    //         "classes": "",
    //         "css": ""
    //     },
    //     "style": {
    //         "fontFamily": "sans-serif",
    //         "fontSize": 26,
    //         "lineHeight": 22,
    //         "color": "#ad937b",
    //         "textAlign": "left"
    //     },
    //     "boxModel": {
    //         "width": "auto",
    //         "height": "auto",
    //         "margin": {
    //             "top": 0,
    //             "bottom": 0,
    //             "left": 0,
    //             "right": 0
    //         },
    //         "padding": {
    //             "top": 10,
    //             "bottom": 10,
    //             "left": 10,
    //             "right": 10
    //         }
    //     },
    //     "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    // },
    {
        "type": "Paragraph",
        "text": unitStatus && unitStatus[0] && unitStatus[0].status
            ? `<a href="${unitStatus[0].status.toLowerCase() === 'available' ? 'https://autographiseries.greengroup.ae/unit-lay-out/5/1' : '#'}"
                  style="color: #ad937b; text-decoration: none; font-family: barlow; font-size: 26px; line-height: 22px; text-align: left;">
                ${unitStatus[0].status.toUpperCase()}<span style="font-size: 18px; vertical-align: middle;"> &#8594; </span>
              </a>`
            : "STATUS NOT AVAILABLE",
        "other": {
            "id": "",
            "classes": "",
            "css": ""
        },
        "style": {
            "fontFamily": "barlow",
            "fontSize": 26,
            "lineHeight": 22,
            "color": "#ad937b",
            "textAlign": "left",
            "fontWeight": "bold"
        },
        "boxModel": {
            "width": "auto",
            "height": "auto",
            "margin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
            },
            "padding": {
                "top": 10,
                "bottom": 10,
                "left": 10,
                "right": 10
            }
        },
        "id": "846b69b4-428e-4ed1-8287-b6838b2f8842"
    }],
    // "actions": {
    //     "click": unitStatus && unitStatus[0].status === 'available' ? "run-script" : "none",
    //     "script": "window.location.href = 'https://autographiseries.greengroup.ae/unit-lay-out/5/1';"
    // },
    "x_image_background": 23.309352517985612,
    "y_image_background": 1.724134637313523,
    "points": [{
        "x": 99.19354838709677,
        "y": 21.816314294628572
    }, {
        "x": 100,
        "y": 0.23458402467342546
    }, {
        "x": 0,
        "y": 0
    }, {
        "x": 0.40322580645162037,
        "y": 95.71028206675761
    }, {
        "x": 29.737903225806445,
        "y": 95.35840625381766
    }, {
        "x": 29.838709677419352,
        "y": 99.93279451087929
    }, {
        "x": 48.38709677419355,
        "y": 100
    }, {
        "x": 48.084677419354854,
        "y": 95.2411135692704
    }, {
        "x": 56.854838709677416,
        "y": 95.24111401741075
    }, {
        "x": 56.04838709677418,
        "y": 22.285482343975424
    }]
}]
}], "version": "6.0.20"
});
            }
        };

        // Wait for the script to load
        const script = document.createElement('script');
        script.src = '/js/image-map-pro.min.js';
        script.onload = initializeImageMap;
        document.head.appendChild(script);
    }, []);

    return (
        // <div>
        //     <div id="image-map-pro"></div>
        // </div>
        <div justifyContent="center" alignItems="center">
          {/* Responsive container for the image map */}
          <div width={{ base: '100%', md: '80%' }} height={{ base: '300px', md: '400px' }} position="relative">
            {/* Ensure the image map fills its parent container */}
            <div id="image-map-pro" height="100%" width="100%"></div>
          </div>
        </div>
    );
}

export default Floor5Component;
